import '../Button/index.scss'
import Button from '@Components/Buttons/Button'
import React from 'react'

interface IProps {
    render: boolean
    disabled: boolean
    onClick: any
}

const SaveDraftButton = (props: IProps) =>
    props.render ? (
        <Button
            mainColor
            type="secondary-small"
            className="save-for-later"
            disabled={props.disabled}
            onClick={props.onClick}
        >
            Save as draft
        </Button>
    ) : (
        <div />
    )

export default SaveDraftButton
